import api from "../services/api";

export default {
    namespaced: true,
    state: {
        loading: false,
        loadError: "",
        users: [],
        dailyExtractionUsers: [],
        vetUsers: [],
        saving: false,
        saveError: ""
    },
  
    getters: {
        loadInProgress(state) {
            return state.loading;
        },
        getUsers(state) {
            return state.users;
        },
        getVetUsers(state) {
            return state.vetUsers;
        },
        getDailyExtractionUsers(state) {
            return state.dailyExtractionUsers;
        }
    },
  
    mutations: {
        setUsers(state, data) {
            state.users = data;
        },
        setVetUsers(state, data) {
            state.vetUsers = data;
        },
        setDailyExtractionUsers(state, data) {
            state.dailyExtractionUsers = data;
        },
        updateUser(state, data){
            for(var i = 0; i < state.users.length; i++){
                if(state.users[i].Email === data.Email){
                    state.users.splice(i, 1, data);
                    return;
                }
            }

            state.users.push(data);
        },
        loading(state) {
            state.loading = true;
            state.loadError = "";
        },
        loadComplete(state) {
            state.loading = false;
        },
        loadError(state, err) {
            state.users = [];
            state.loadError = err;
        },
        saving(state) {
            state.saving = true;
            state.saveError = "";
        },
        saveComplete(state) {
            state.saving = false;
        },
        saveError(state, err) {
            state.saveError = err;
        }
    },
  
    actions: {
        saveUser(context, options) {
            context.commit("saving");

            api.saveUser(
                options.user,
                {
                    success: function(response) {
                        // the response we get back from this function is the updated user (which will include the changes we requested)
                        context.commit("updateUser", response.data.UserProfile);

                        if (options.success) {
                            options.success(response);
                        }
                    },
                    error: function(e) {
                        context.commit("saveError", api.parseHttpRequestError(e));

                        if (options.error) {
                            options.error(e);
                        }
                    },
                    finally: function() {
                        context.commit("saveComplete");

                        if (options.finally) {
                            options.finally();
                        }
                    }
                }
            );
        },
        loadDailyExtractionUsers(context) {
            context.commit("loading");

            api.fetchUsers({
                success: function(response) {
                    context.commit("setDailyExtractionUsers", response.data.Users);
                },
                error: function(e) {
                    context.commit("loadError", api.parseHttpRequestError(e));
                },
                finally: function() {
                    context.commit("loadComplete");
                },
                params: {
                    dailyExtractionUsersOnly: true
                }
            });
        },
        loadUsers(context) {
            context.commit("loading");

            api.fetchUsers({
                success: function(response) {
                    context.commit("setUsers", response.data.Users);
                    // filter vet users
                    var vetUsers = response.data.Users.filter(function(user) {
                        if(user.Permissions == null || user.Permissions == undefined) return false;
                        return Object.keys(user.Permissions).indexOf("vet_med_team") > -1 || Object.keys(user.Permissions).indexOf("admin") > -1;
                    });
                    context.commit("setVetUsers", vetUsers);
                },
                error: function(e) {
                    context.commit("loadError", api.parseHttpRequestError(e));
                },
                finally: function() {
                    context.commit("loadComplete");
                }
            });
        }
    }
}
